namespace GeniuzPOS.InitialData {
    export interface PsCurrencyRow {
        Id?: number;
        CurrencyCode?: string;
        CurrencyName?: string;
        IsActive?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ProdImageLink?: string;
    }

    export namespace PsCurrencyRow {
        export const idProperty = 'CurrencyCode';
        export const nameProperty = 'CurrencyCode';
        export const localTextPrefix = 'InitialData.PsCurrency';
        export const lookupKey = 'InitialData.PsCurrency';

        export function getLookup(): Q.Lookup<PsCurrencyRow> {
            return Q.getLookup<PsCurrencyRow>('InitialData.PsCurrency');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:สกุลเงิน:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:สกุลเงิน:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:สกุลเงิน:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:สกุลเงิน:Modify';

        export declare const enum Fields {
            Id = "Id",
            CurrencyCode = "CurrencyCode",
            CurrencyName = "CurrencyName",
            IsActive = "IsActive",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ProdImageLink = "ProdImageLink"
        }
    }
}
